import React from 'react';
import { Stack, Typography } from '@mui/material';
import empty from '../../assets/No data.gif';

const RnRNotStarted = () => {
  return (
    <Stack display={'flex'} alignItems={'center'} sx={{ p: 1 }} justifyContent={'center'} height={'30vh'}>
      <img style={{ width: '70%' }} src={empty} alt='pending' />
      <Typography sx={{ fontSize: '16px', color: 'rgba(0,0,0,0.7)' }}>
        {"RnR Nominations hasn't Started Yet"}
      </Typography>
    </Stack>
  );
};

export default RnRNotStarted;
